import { useAutocomplete } from 'admin';
import type { SimpleTradeSiteListItem } from 'api';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

type Props = Omit<AutocompleteFieldProps<SimpleTradeSiteListItem>, 'options' | 'defaultValue'> & {
  defaultValue?: SimpleTradeSiteListItem['id'];
};

export const SiteAutocomplete = ({ required = false, defaultValue, ...rest }: Props) => {
  const { autocompleteProps } = useAutocomplete<SimpleTradeSiteListItem>({
    dataProviderName: 'trade',
    defaultValue,
    onSearch: (value) => [
      {
        field: 'search',
        operator: 'contains',
        value,
      },
    ],
    resource: `/v1/trade-sites/`,
  });

  return (
    <AutocompleteField<SimpleTradeSiteListItem>
      {...autocompleteProps}
      getOptionLabel={(option) => option.full_address}
      isOptionEqualToValue={(option, value) => {
        return value === undefined || option?.id?.toString() === (value?.id ?? value)?.toString();
      }}
      valueField="id"
      required={required}
      {...rest}
    />
  );
};
